import config from 'config';
import { utilities } from 'core/use-cases';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import { rootReducer } from './root-reducer';

const persistReducerConfig = {
  storage: utilities.storage,
  key: `${config.app.short}-stargate`,
  blacklist: [],
  whitelist: ['auth', 'cart', 'checkout', 'content', 'settings', 'search', 'version'],
  stateReconciler: autoMergeLevel2,
};

export const persistedReducer = utilities.persistReducer<ReturnType<typeof rootReducer>>(
  persistReducerConfig,
  rootReducer,
);
